import React from "react";
import classes from "./ProductCard.module.css"
import BriefDesc from "./BriefDesc/BriefDesc";

const ProductCard = () => {
    // console.log(window.location.search.slice(1))
    return (
        <div className={classes.ProductCard}>
            {/* <img src={window.location.search.slice(1) === "4753-10/1" ? АМР_4753_10 : null} alt="" /> */}
            <BriefDesc title={window.location.search.slice(1)}/>
        </div>
    )
}

export default ProductCard